module.exports = __webpack_public_path__ + "static/media/monetization_on_white_24dp.70bc844c.svg";